<div class="info-card-container">
    @for (infoCard of infoCards; track infoCard) {
        <wdx-info-card [ngClass]="infoCard.bgColour">
            @if (infoCard.icon) {
                <div wdxInfoCardLeading wdxInfoCardSeparator>
                    <wdx-icon
                        [icon]="infoCard.icon"
                        [ngClass]="infoCard.iconColour"
                        [class.bg-icon]="infoCard.iconBackground"
                        class="icon--image icon-container d-flex justify-content-center align-items-center rounded-circle icon-container-size-md"
                    >
                    </wdx-icon>
                </div>
            }
            <div wdxInfoCardLabel [ngClass]="infoCard.textColour">
                {{ infoCard.value | translateTokenisedString }}
            </div>
            <div wdxInfoCardSub [ngClass]="infoCard.textColour">
                {{ infoCard.label | translateTokenisedString }}
            </div>
        </wdx-info-card>
    }
</div>
